:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

.specifications-table {
  font-size: rem-calc(14);
  line-height: rem-calc(20);
  font-weight: normal;
  color: #333333;
  width: 100%;
  height: auto;
  border-collapse: collapse;
  max-width: 980px;
}

.specifications-table__caption {
  font-size: rem-calc(16);
  background-color: #f3f2f2;
  color: #333333;
}

:host(:not([dir="rtl"])) .specifications-table__caption {
  padding: 0 24px 0 15px;
  text-align: left;
}

:host([dir="rtl"]) .specifications-table__caption {
  padding: 0 15px 0 24px;
  text-align: right;
}

@media screen and (max-width: 979px) {
  .specifications-table__caption {
    line-height: 45px;
  }
}

@media screen and (min-width: 980px) {
  .specifications-table__caption {
    line-height: 40px;
  }
}

.specifications-table__row {
  border-bottom: 1px solid #e7e6e6;
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 979px) {
  .specifications-table__row {
    padding: 10px 0;
    margin: 0 15px;
  }
}

@media screen and (min-width: 980px) {
  .specifications-table__row {
    padding: 14px 0;
    flex-direction: row;
  }
}

.specifications-table__row:last-child {
  border: none;
}

.specifications-table__cell,
.specifications-table__row-heading {
  vertical-align: top;
  white-space: normal;
  padding: 0;
}

:host(:not([dir="rtl"])) .specifications-table__cell,
:host(:not([dir="rtl"])) .specifications-table__row-heading {
  text-align: left;
}

:host([dir="rtl"]) .specifications-table__cell,
:host([dir="rtl"]) .specifications-table__row-heading {
  text-align: right;
}

@media screen and (max-width: 979px) {
  .specifications-table__row-heading {
    padding-bottom: 4px;
  }
}

@media screen and (min-width: 980px) {
  .specifications-table__row-heading {
    width: 32.3%;
  }

  :host(:not([dir="rtl"])) .specifications-table__row-heading {
    padding-left: 15px;
  }

  :host([dir="rtl"]) .specifications-table__row-heading {
    padding-right: 15px;
  }
}

@media screen and (min-width: 980px) {
  .specifications-table__cell {
    max-width: 67.7%;
  }

  :host(:not([dir="rtl"])) .specifications-table__cell {
    padding-left: 24px;
  }

  :host([dir="rtl"]) .specifications-table__cell {
    padding-right: 24px;
  }
}

@media screen and (max-width: 979px) {
  .specifications-table__max-capacity {
    padding-top: 4px;
  }
}

.specifications-table__max-capacity-bar {
  width: 250px;
}

@media screen and (max-width: 979px) {
  .specifications-table__max-capacity-bar {
    width: 100%;
    padding-top: 10px;
    padding-bottom: 8px;
  }
}

.specifications-table__link {
  display: inline-block;
  font-weight: normal;
}

:host(:not([dir="rtl"])) .specifications-table__link {
  padding-right: 10px;
}

:host([dir="rtl"]) .specifications-table__link {
  padding-left: 10px;
}

@media screen and (min-width: 980px) {
  .specifications-table__link {
    padding: 0;
  }
}

.specifications-table__text--first-letter-uppercase {
  display: inline-block;
}

.specifications-table__text--first-letter-uppercase:first-letter {
  text-transform: uppercase;
}